import React from 'react';
import OnboardingIndex from './OnboardingIndex';

const OnboardingAccounting = () => {
  return <OnboardingIndex isAccounting />;
};

export default OnboardingAccounting;
